import { Component, OnInit, Renderer2, ElementRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';

// env
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

// Plugin
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-organi-structure',
  templateUrl: './organi-structure.component.html',
})
export class OrganiStructureComponent implements OnInit {

  @ViewChild('autoShownModal', { static: false }) autoShownModal: ModalDirective;
  isModalShown = false;
  modalImg: string;
  modalDetail: string;
  modalName: string;
  modalPosition: string;
  apiAsset = environment.API_ASSETS;
  dataTitle;
  dataBOC;
  dataBOD;
  dataHOD;
  dataSOM;
  dataBOCTitle;
  dataBODTitle;
  dataHODTitle;
  dataSOMTitle;

  constructor( private renderer: Renderer2,
               private elem: ElementRef,
               private apiService: ApiService, 
               private globalService : GlobalService,
               private router: Router) { 
    this.globalService.isLoading.next(true);          
  }


  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getMenuSection/organization-structure').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // directors 
    this.apiService.getDataApi('getDirector?category=1').subscribe(response => {
        this.dataBOC = response.data.content;
        this.dataBOCTitle = response.data.category.title;
    });
    this.apiService.getDataApi('getDirector?category=2').subscribe(response => {
      this.dataBOD = response.data.content;
      this.dataBODTitle = response.data.category.title;
    });
    this.apiService.getDataApi('getDirector?category=3').subscribe(response => {
      this.dataHOD = response.data.content;
      this.dataHODTitle = response.data.category.title;
    });
    this.apiService.getDataApi('getDirector?category=4').subscribe(response => {
      this.dataSOM = response.data.content;
      this.dataSOMTitle = response.data.category.title;      
    });
  }

  showAccordion(ev){
    const target = ev.currentTarget;
    const parent = this.renderer.parentNode(target);
    if(parent.classList.contains('active')){
      this.renderer.removeClass(parent, 'active');
    }else{
      this.renderer.addClass(parent, 'active');
    }
  }

  showModal(people): void {
    this.isModalShown = true;
    this.modalDetail = people.description;
    this.modalImg = people.picture;
    this.modalPosition = people.position;
    this.modalName = people.fullname;
  }
 
  hideModal(): void {
    this.autoShownModal.hide();
  }
 
  onHidden(): void {
    this.isModalShown = false;
  }

}
